import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { User, UserDetails } from '../../../shared/models/user';
import { PaginatedResponse } from '../../../shared/interfaces/pagination';
import { Permission } from '../models/permission';
import { UserInvitation } from '../../manage-connection-group/models/user-invitation';
import { CreateUser } from '../models/create-user';

@Injectable({
  providedIn: 'root',
})
export class ManageUsersService {
  private http: HttpClient = inject(HttpClient);

  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getAllUsers(
    pageNo = 1,
    pageSize = 10,
    connections: string[] = [],
    search = '',
    skipLoader = false,
    sme?: boolean,
  ): Observable<PaginatedResponse<UserDetails>> {
    let params = new HttpParams();
    params = params.set('page', pageNo.toString());
    params = params.set('page_size', pageSize.toString());
    if (connections.length > 0) {
      params = params.set('connections', connections.join(','));
    }
    if (search && search.trim().length > 0) {
      params = params.set('search', search.trim());
    }
    if (sme !== undefined) {
      params = params.set('sme', sme.toString());
    }
    return this.http.get<PaginatedResponse<UserDetails>>(
      this.adminApiBaseUrl + '/users',
      {
        params,
        headers: {
          'X-Skip-Loader': skipLoader ? 'true' : 'false',
        },
      },
    );
  }

  getPermissionsForUser(userId: number): Observable<Permission> {
    return this.http.get<Permission>(
      `${this.adminApiBaseUrl}/user/${userId}/permissions`,
    );
  }

  addUserPermissionForUser(permissionId: number, userId: number) {
    return this.http.post(
      `${this.adminApiBaseUrl}/user/${userId}/permission/${permissionId}`,
      {},
    );
  }

  deleteUserPermissionForUser(permissionId: number, userId: number) {
    return this.http.delete(
      `${this.adminApiBaseUrl}/user/${userId}/permission/${permissionId}`,
    );
  }

  getUserInvitaionDetails(invitationUrlId: string): Observable<UserInvitation> {
    return this.http.get<UserInvitation>(
      `${this.adminApiBaseUrl}/users/invite/${invitationUrlId}`,
    );
  }

  deleteUserInvitation(invitationUrlId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.adminApiBaseUrl}/users/invite/${invitationUrlId}/cancel`,
    );
  }

  createUser(userModel: CreateUser, invitationUrlId: string): Observable<User> {
    return this.http.put<User>(
      `${this.adminApiBaseUrl}/users/invite/${invitationUrlId}`,
      userModel,
    );
  }
}
